import { UNLOAD_CURRENT_ARTIST } from '../actionTypes';

export const currentSong = (state = null, action) => {
  switch (action.type) {
    case UNLOAD_CURRENT_ARTIST:
      return null;

    default:
      return state;
  }
};
